
import './css/index.css'
import dommusLogo from "../../../../../assets/images/dommus-mobile.png" ;
import { Fragment, useContext, useEffect } from 'react';
import DommusBoxChat from '../../../../DommusBoxChat';
import { ChatAtendenteContext } from '../../../../../contexts/ChatAtendenteContext';
import { animate } from 'motion/react';
import { PusherContext } from '../../../../../contexts/PusherContext';

export const DommusBtnAtendimentoChat = () => {

  const {openBtnChat, setOpenModalChat, openModalChat, atendimentoAtivo} = useContext(ChatAtendenteContext);
  const pusher = useContext(PusherContext);

  useEffect(()=>{
    setTimeout(()=>{
      animate(".dommus-box-chat",
              { opacity: [Number(!openModalChat), Number(openModalChat)] },
              { duration: 0.2, delay: 0.2 })
    },10)
  },[openModalChat])    

  useEffect(() => {
    pusher?.pusherState && pusher.pusherState.bind(`mensagem_recebida.${atendimentoAtivo.id}`, function(data:any) {
        debugger
    }) 
    return () => pusher?.pusherState.unbind();
  }, [pusher?.pusherState])
  
  return (
      <Fragment>
          {openBtnChat && <DommusBoxChat />}
          <div 
            className="dommus-btn-atendimento-chat"
            onClick={() => {
              setOpenModalChat((current) => !current);
            }}
          >
              <img style={{width:'50px',height:'50px',objectFit:'contain'}} src={dommusLogo} alt="dommus"  />
          </div>
      </Fragment>
  )
}


